import { useDispatch, useSelector } from "react-redux";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getRefreshToken } from "./SessionManager.js";
import { renewToken } from "../features/auth/authSlice.js";
import { useEffect, useState } from "react";
import { handleLogOut } from "./Methods.js";

export const SessionExpiryPopup = ({ IfSessionExpiry, setIfSessionExpiry }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (IfSessionExpiry) {
      setOpen(true);
    }
  }, [IfSessionExpiry]);

  const handleYes = async () => {
    setOpen(false);
    setIfSessionExpiry(false);
    const renewTokenResult = await dispatch(
      renewToken(getRefreshToken(window))
    );
    if (renewTokenResult?.payload?.error?.errorCode === "BAD_REQUEST") {
      alert("Renewal token is expired. Login again to access the screen");
      handleLogOut(dispatch, navigate);
    }
  };

  const handleNo = () => {
    setOpen(false);
    setIfSessionExpiry(false);
    window.sessionStorage.clear();
    handleLogOut(dispatch, navigate);
  };

  return (
    <Dialog open={open} onClose={handleNo}>
      <DialogTitle>Session Expiry Warning</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Your session is expired. Do you want to renew your session?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleYes} color="primary" autoFocus>
          Yes
        </Button>
        <Button onClick={handleNo} color="primary">
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};
